import { useLocation } from '@xing-com/crate-core-router';
import { useExperiment } from '@xing-com/hub';

export const PAY_OR_CONSENT_UPSELL_URL = '/purchase/premium';
export const PAY_OR_CONSENT_UPSELL_MID = 'co';
export const PAY_OR_CONSENT_UPSELL_REAGENT = 'uplt_1072';
export const PAY_OR_CONSENT_STANDARD_UPSELL_MID = 'cob';
export const PAY_OR_CONSENT_STANDARD_UPSELL_REAGENT = 'uplt_1074';

export const PAY_OR_CONSENT_UPSELL_HREF = `${PAY_OR_CONSENT_UPSELL_URL}?mid=${PAY_OR_CONSENT_UPSELL_MID}&reagent=${PAY_OR_CONSENT_UPSELL_REAGENT}`;
export const PAY_OR_CONSENT_STANDARD_UPSELL_HREF = `${PAY_OR_CONSENT_UPSELL_URL}?mid=${PAY_OR_CONSENT_STANDARD_UPSELL_MID}&reagent=${PAY_OR_CONSENT_STANDARD_UPSELL_REAGENT}`;

export const isPayOrConsentUpsellMid = (mid?: string | null): boolean =>
  mid === PAY_OR_CONSENT_UPSELL_MID ||
  mid === PAY_OR_CONSENT_STANDARD_UPSELL_MID;

export const normalizePayOrConsentUpsellMid = (
  mid: string | undefined,
  isPayOrConsentExperimentEnabled: boolean
): string | undefined =>
  isPayOrConsentUpsellMid(mid) && !isPayOrConsentExperimentEnabled
    ? undefined
    : mid;

export const usePayOrConsentCampaignMid = (): string | undefined => {
  const { search } = useLocation();
  const locationSearch =
    search ?? (typeof window === 'undefined' ? '' : window.location.search);
  const originalMid =
    new URLSearchParams(locationSearch).get('mid') ?? undefined;
  const isPayOrConsentExperimentEnabled = useExperiment('ABACUS-546') === 'B';

  return normalizePayOrConsentUpsellMid(
    originalMid,
    isPayOrConsentExperimentEnabled
  );
};
